import { StripeVolumePricingConfig } from '../../../../shared/graphql/graphql';
import { getCurrencyForAreaUnit } from '../../../../shared/helpers/functions/currency';
import { convertStripeAmount } from '../../../../shared/helpers/functions/number';
import useStripeSubscriptionPreview from './useStripeSubscriptionPreview';
import usePriceConfig from '../../../../shared/features/priceConfig/hooks/usePriceConfig';
import rootStore from '../../rootStore/RootStore';
import SubscriptionPreviewTable from '../components/SubscriptionPreviewTable';
import { getTiersFromPreview } from '../helpers/functions/tiers';

export default function useAnnualSubscriptionPreview() {
  const { areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;
  const { config } = usePriceConfig(rootStore);
  const { preview } = useStripeSubscriptionPreview();
  const currency = getCurrencyForAreaUnit(areaUnit);

  const volumePricing = config?.AnnualSubscription
    .FullAccessToEssentialFunctionalities.prices[currency]
    .volumePricing as StripeVolumePricingConfig[];

  const annualSubscriptionPrice =
    config?.AnnualSubscription.FullAccessToEssentialFunctionalities.prices[
      currency
    ];
  const seatsPrice =
    config?.AnnualSubscription.AdditionalUserSeat.prices[currency];
  const planetPrice = config?.AnnualSubscription.PlanetImagery.prices[currency];

  const seatsLine = (preview?.lines ?? []).find(
    (lineItem) => lineItem?.priceId === seatsPrice?.priceId,
  );
  const planetLine = (preview?.lines ?? []).find(
    (lineItem) => lineItem?.priceId === planetPrice?.priceId,
  );

  const tiers = getTiersFromPreview(
    annualSubscriptionPrice?.priceId ?? '',
    preview?.lines ?? [],
    volumePricing ?? [],
  );

  const discount = (preview?.totalDiscountAmounts ?? [])?.reduce(
    (acc, discountAmount) => acc + (discountAmount?.amount ?? 0),
    0,
  );

  const getSubscriptionPreviewTable = () => (
    <SubscriptionPreviewTable
      areaUnit={areaUnit}
      tiers={tiers}
      seats={{
        amount: seatsLine?.quantity ?? 0,
        price: seatsPrice?.price ?? 0,
        cost: convertStripeAmount(seatsLine?.amount),
      }}
      planet={{
        amount: planetLine?.quantity ?? 0,
        price: planetPrice?.price ?? 0,
        cost: convertStripeAmount(planetLine?.amount),
      }}
    />
  );

  return {
    subTotalCost: convertStripeAmount(preview?.subtotal),
    discount: convertStripeAmount(discount),
    tax: convertStripeAmount(preview?.tax),
    totalCost: convertStripeAmount(preview?.total),
    getSubscriptionPreviewTable,
  };
}
